import { Helmet } from 'react-helmet-async';

interface JobPostingSchemaProps {
  title: string;
  description: string;
  datePosted: string;
  validThrough?: string;
  employmentType?: string;
  hiringOrganization: {
    name: string;
    sameAs: string;
    logo?: string;
  };
  jobLocation: {
    streetAddress?: string;
    addressLocality?: string;
    addressRegion?: string;
    postalCode?: string;
    addressCountry: string;
  };
  baseSalary?: {
    currency: string;
    value: number | { minValue: number; maxValue: number; unitText: string };
  };
}

export const JobPostingSchema = ({
  title,
  description,
  datePosted,
  validThrough,
  employmentType = "FULL_TIME",
  hiringOrganization,
  jobLocation,
  baseSalary
}: JobPostingSchemaProps) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "JobPosting",
    "title": title,
    "description": description,
    "datePosted": datePosted,
    "validThrough": validThrough,
    "employmentType": employmentType,
    "hiringOrganization": {
      "@type": "Organization",
      "name": hiringOrganization.name,
      "sameAs": hiringOrganization.sameAs,
      "logo": hiringOrganization.logo
    },
    "jobLocation": {
      "@type": "Place",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": jobLocation.streetAddress,
        "addressLocality": jobLocation.addressLocality,
        "addressRegion": jobLocation.addressRegion,
        "postalCode": jobLocation.postalCode,
        "addressCountry": jobLocation.addressCountry
      }
    },
    ...(baseSalary && {
      "baseSalary": {
        "@type": "MonetaryAmount",
        "currency": baseSalary.currency,
        "value": typeof baseSalary.value === 'number' ? baseSalary.value : {
          "@type": "QuantitativeValue",
          "minValue": baseSalary.value.minValue,
          "maxValue": baseSalary.value.maxValue,
          "unitText": baseSalary.value.unitText
        }
      }
    })
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};
